(function ($, Drupal, window, document) {

  Drupal.behaviors.SlickConfig = {
    attach: function (context, settings) {

      $('.slider-thumb').not('.slick-initialized').slick({
        autoplay: false,
        vertical: true,
        infinite: true,
        verticalSwiping: true,
        slidesPerRow: 4,
        slidesToShow: 4,
        draggable: true,
        asNavFor: '.slider-preview',
        focusOnSelect: true,
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-up"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-down"></i></button>',
        responsive: [
          {
            breakpoint: 747,
            settings: {
              vertical: false,
              prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
              nextArrow: '<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
            }
          },
          {
            breakpoint: 479,
            settings: {
              vertical: false,
              slidesPerRow: 3,
              slidesToShow: 3,
            }
          },
        ]
      });
      $('.slider-preview').not('.slick-initialized').slick({
        autoplay: false,
        vertical: true,
        infinite: true,
        slidesPerRow: 1,
        slidesToShow: 1,
        asNavFor: '.slider-thumb',
        arrows: false,
        draggable: false,
        responsive: [
          {
            breakpoint: 747,
            settings: {
              vertical: false,
              fade: true,
            }
          },
        ]
      });

    }
  };

}(jQuery, Drupal, this, this.document));
